
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/trainings/details/[slug]",
      function () {
        return require("private-next-pages/[lang]/trainings/details/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/trainings/details/[slug]"])
      });
    }
  